module.exports = __webpack_public_path__ + "img/moveDown.5308db04.svg";